/* eslint-disable import/no-anonymous-default-export */
import criteria from "src/utils/criteria";
import { livingArrangementsTypes, typeOfSaleList, declarationAnswers } from "src/constants";

const {
  PROPERTY_OWNER,
  SPOUSE_OWNED_PROPERTY,
  RENTING,
  BOARDING,
  LIVING_WITH_PARENTS
} = livingArrangementsTypes

const {
  assetCondition,
  livingArrangements,
  typeOfSale,
  assetValueBetween,
  assetType,
  ageOfAssetLessThanYearly,
  ageOfAssetAtEndLessThan,
  loanAmountBetween,
  gstRegistrationGreaterThan,
  timeInBusinessGreaterThan,
  timeInBusinessLessThan,
  creditScoreGreaterThan,
  brokerageAmount,
  hireRentalOrLuxuryAsset,
} = criteria;

const {
  DEALER_SALE,
  PRIVATE_SALE,
  MID_TERM_REFINANCE,
  BALLOON_RESIDUAL_REFINANCE,
  SALE_BUYBACK_EQUITY
} = typeOfSaleList

export default {
  date: "28 Mar 2025",
  lender: "Group & General Finance",
  type: "commercial",
  logoURL: "https://assets.financeable.com.au/lender-logos%2FG%26G%2Blogo.gif",
  fees: [
    {
      name: "Origination fee",
      value: 1299,
      capitalised: true,
      frequency: "upfront",
    },
    {
      name: "Document fee",
      value: 649,
      capitalised: true,
      frequency: "upfront",
    },
  ],
  brokerage: [
    {
      value: 4,
      max: 8,
      valueType: "percentage",
      criteria: [assetValueBetween(10000, 100000)],
    },
    {
      value: 4,
      max: 6,
      valueType: "percentage",
      criteria: [assetValueBetween(100000.01, 300001)],
    },
  ],
  loading: [
    // {
    //   name: "Non property owner",
    //   value: 2,
    //   valueType: "percentage",
    //   criteria: [livingArrangements([RENTING, BOARDING, LIVING_WITH_PARENTS]),],
    // },
    {
      name: "Private sale",
      value: 1,
      valueType: "percentage",
      criteria: [typeOfSale(typeOfSaleList.PRIVATE_SALE)],
    },
    {
      name: "Brokerage 5%",
      value: 0.5,
      valueType: "percentage",
      criteria: [brokerageAmount(5, 5.9)],
    },
    {
      name: "Brokerage 6%",
      value: 1,
      valueType: "percentage",
      criteria: [brokerageAmount(6, 6.9)],
    },
    {
      name: "Brokerage 7%",
      value: 1.5,
      valueType: "percentage",
      criteria: [brokerageAmount(7, 7.9)],
    },
    {
      name: "Brokerage 8%",
      value: 2,
      valueType: "percentage",
      criteria: [brokerageAmount(8, 8.1)],
    },
    {
      name: "Mid term refinance",
      value: 1,
      valueType: "percentage",
      criteria: [typeOfSale(typeOfSaleList.MID_TERM_REFINANCE)],
    },
    {
      name: "Sale & buyback | Equity",
      value: 1,
      valueType: "percentage",
      criteria: [typeOfSale(typeOfSaleList.SALE_BUYBACK_EQUITY)],
    },
    {
      name: "ABN <24 months",
      value: 2,
      valueType: "percentage",
      criteria: [timeInBusinessLessThan(24)],
    },
    {
      name: "Hire/rental, uber, courier, bus, luxury/exotic or tier 2 asset",
      value: 1.5,
      valueType: "percentage",
      criteria: [hireRentalOrLuxuryAsset(declarationAnswers.YES)],
    },
    // {
    //   name: "Loan amount >$150k",
    //   value: 0.5,
    //   valueType: "percentage",
    //   criteria: [loanAmountGreaterThan(150000)],
    // },
  ],
  info: [
    "Bankstatements required for all applications",
    "100k - Max lend for non-property",
    "Income: Brokerage: 4% included, Max of 6% with 1 % rate load",
    "Additional rate loads for Adverse and scores <650 (Express) and <600 (light Doc)",
    "ATO arrears - may have a rate load (GGF discretion)",
    "Hire / Rental / UBER / Courier may have a rate load - 1-4% (GGF discretion)",
    "Max term 60 mths",
    "Max balloons/residuals 30% (restricted to <24mths age at start)"
  ],
  productTiers: [
    {
      name: "Express",
      rate: 7.36,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 150000),
        ageOfAssetLessThanYearly(1),
        assetType(["Cars, Utes & Vans"]),
        assetCondition(["New", "Demo"]),
        ageOfAssetAtEndLessThan(30),
        timeInBusinessGreaterThan(35),
        gstRegistrationGreaterThan(35),
        creditScoreGreaterThan(651),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([DEALER_SALE])
      ],
    },
    {
      name: "Express",
      rate: 7.36,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 150000),
        ageOfAssetLessThanYearly(1),
        assetType(["Trucks & Equipment"]),
        assetCondition(["New", "Demo"]),
        ageOfAssetAtEndLessThan(30),
        timeInBusinessGreaterThan(35),
        gstRegistrationGreaterThan(35),
        creditScoreGreaterThan(651),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([DEALER_SALE])
      ],
    },

    {
      name: "Express",
      rate: 7.58,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 150000),
        ageOfAssetLessThanYearly(5),
        assetType(["Cars, Utes & Vans"]),
        assetCondition(["Used"]),
        ageOfAssetAtEndLessThan(30),
        timeInBusinessGreaterThan(35),
        gstRegistrationGreaterThan(35),
        creditScoreGreaterThan(651),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([DEALER_SALE])
      ],
    },
    {
      name: "Express",
      rate: 7.58,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 150000),
        ageOfAssetLessThanYearly(5),
        assetType(["Trucks & Equipment"]),
        assetCondition(["Used"]),
        ageOfAssetAtEndLessThan(30),
        timeInBusinessGreaterThan(35),
        gstRegistrationGreaterThan(35),
        creditScoreGreaterThan(651),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([DEALER_SALE])
      ],
    },

    {
      name: "Light doc",
      rate: 7.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        ageOfAssetLessThanYearly(1),
        assetCondition(["New", "Demo"]),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,
          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 8.19,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        ageOfAssetLessThanYearly(5),
        assetType(["Cars, Utes & Vans"]),
        assetCondition(["Used"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 8.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        ageOfAssetLessThanYearly(9),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 9.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 10.99,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },



    {
      name: "Light doc",
      rate: 7.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        assetType(["Trucks & Equipment"]),
        ageOfAssetLessThanYearly(1),
        assetCondition(["New", "Demo"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 8.19,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        ageOfAssetLessThanYearly(5),
        assetType(["Trucks & Equipment"]),
        assetCondition(["Used"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 8.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        ageOfAssetLessThanYearly(9),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 9.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 10.99,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 350000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },



    {
      name: "Light doc",
      rate: 9.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(1),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 10.19,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(5),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 10.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(9),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 11.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 12.99,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,
          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 9.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(2),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 10.19,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(5),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 10.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(9),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 11.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 12.99,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },


    {
      name: "Express - Replacement",
      rate: 7.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        assetType(["Cars, Utes & Vans"]),
        ageOfAssetLessThanYearly(1),
        assetCondition(["New", "Demo"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 8.19,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        ageOfAssetLessThanYearly(5),
        assetType(["Cars, Utes & Vans"]),
        assetCondition(["Used"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 8.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        ageOfAssetLessThanYearly(9),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 9.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 10.99,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    
    {
      name: "Express - Replacement",
      rate: 7.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        assetType(["Trucks & Equipment"]),
        ageOfAssetLessThanYearly(1),
        assetCondition(["New", "Demo"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 8.19,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        ageOfAssetLessThanYearly(5),
        assetType(["Trucks & Equipment"]),
        assetCondition(["Used"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 8.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        ageOfAssetLessThanYearly(9),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 9.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 10.99,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 200000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },


    {
      name: "Express - Replacement",
      rate: 9.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(2),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 10.19,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(5),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 10.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(9),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 11.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 12.99,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 9.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(2),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 10.19,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(5),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 10.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(9),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 11.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 12.99,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },



    {
      name: "Express - Residual",
      rate: 7.89,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 150000),
        assetType([
          "Cars, Utes & Vans",
          "Trucks & Equipment"
        ]),
        ageOfAssetAtEndLessThan(12),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([PROPERTY_OWNER]),
        typeOfSale([
          BALLOON_RESIDUAL_REFINANCE,
        ])
      ],
    },
    {
      name: "Express - Residual",
      rate: 8.89,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        assetType([
          "Cars, Utes & Vans",
          "Trucks & Equipment"
        ]),
        ageOfAssetAtEndLessThan(12),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          RENTING,
          BOARDING,
          LIVING_WITH_PARENTS
        ]),
        typeOfSale([
          BALLOON_RESIDUAL_REFINANCE,
        ])
      ],
    },


    {
      name: "Light doc",
      rate: 8.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(2),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 9.19,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(5),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 9.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(9),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 10.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 11.99,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 8.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(2),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 9.19,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(5),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 9.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(9),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 10.69,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,
          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Light doc",
      rate: 11.99,
      productType: "Light doc",
      excludedRequiredFields: [],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,
          SALE_BUYBACK_EQUITY
        ])
      ],
    },


    {
      name: "Express - Residual",
      rate: 8.89,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        assetType([
          "Cars, Utes & Vans",
          "Trucks & Equipment"
        ]),
        ageOfAssetAtEndLessThan(12),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          BALLOON_RESIDUAL_REFINANCE,
        ])
      ],
    },





    {
      name: "Express - Replacement",
      rate: 8.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        assetType(["Cars, Utes & Vans"]),
        ageOfAssetLessThanYearly(1),
        assetCondition(["New", "Demo"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 9.19,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(5),
        assetType(["Cars, Utes & Vans"]),
        assetCondition(["Used"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 9.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(9),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 10.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 11.99,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Cars, Utes & Vans"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 10.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        assetType(["Trucks & Equipment"]),
        ageOfAssetLessThanYearly(1),
        assetCondition(["New", "Demo"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 11.19,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(5),
        assetType(["Trucks & Equipment"]),
        assetCondition(["Used"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 11.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(9),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 12.69,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
    {
      name: "Express - Replacement",
      rate: 13.99,
      productType: "Low doc",
      excludedRequiredFields: ["bankStatements"],
      info: [],
      criteria: [
        loanAmountBetween(10000, 100000),
        // ageOfAssetLessThanYearly(15),
        assetType(["Trucks & Equipment"]),
        timeInBusinessGreaterThan(0),
        gstRegistrationGreaterThan(0),
        creditScoreGreaterThan(601),
        livingArrangements([
          SPOUSE_OWNED_PROPERTY
        ]),
        typeOfSale([
          DEALER_SALE,
          PRIVATE_SALE,
          MID_TERM_REFINANCE,

          SALE_BUYBACK_EQUITY
        ])
      ],
    },
  ],
};